import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "about"
};
const _hoisted_3 = {
  class: "list"
};
const _hoisted_4 = {
  style: {
    "text-align": "left"
  }
};
const _hoisted_5 = {
  class: "item-title"
};
const _hoisted_6 = {
  class: "item-time"
};
const _hoisted_7 = {
  class: "item-content"
};
const _hoisted_8 = ["src"];
import { ref } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const list = ref([{
      img: require('@/assets/img5.png'),
      title: '信用金上线特惠首借年利率3.6%单利',
      time: '2023-04-30',
      content: '浙里金消联合宁波银行特推出专属于金华人的信用金贷款，首期利息仅需3.6%起（单利），一起放肆花吧~'
    }, {
      img: require('@/assets/img8.png'),
      title: '最高50-25！福泰隆超市助力政府消费券可叠加使用',
      time: '2023-04-29',
      content: '金华福泰隆5员消费券，可与金华普惠券叠加使用。'
    }, {
      img: require('@/assets/img9.png'),
      title: '五一更疯狂，码上领补贴',
      time: '2023-04-26',
      content: '“浙里来消费·嗨购金兔年”首届“码上购车补贴”暨全市汽车品牌向百人企业发放叠加购车补贴。'
    }, {
      img: require('@/assets/img10.png'),
      title: '买立马电动车享“立马”省钱',
      time: '2023-04-13',
      content: '2023年1 月1日起非标电动自行车不能上路啦!快来挑选一辆更安全、更轻便的新国标电动车吧~'
    }, {
      img: require('@/assets/img11.png'),
      title: '春暖花开季，出行正当时，打车优惠券来啦',
      time: '春暖花开季，出行正当时，打车优惠券来啦',
      content: '春暖花已渐开，滴滴打车出行发放优惠券啦,浙里金消用户专属福利,小伙伴们赶紧看过来。'
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "banner"
      }, null, -1)), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "us-title"
      }, "LATEST NEWS", -1)), _cache[1] || (_cache[1] = _createElementVNode("h3", {
        class: "title"
      }, "最新资讯", -1)), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "list-item flex align-center justify-between",
          key: item.title
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.time), 1), _createElementVNode("div", _hoisted_7, _toDisplayString(item.content), 1)]), _createElementVNode("img", {
          src: item.img,
          style: {
            "width": "330px",
            "height": "210px"
          },
          alt: ""
        }, null, 8, _hoisted_8)]);
      }), 128))])])])], 64);
    };
  }
};